import { useShallow } from 'zustand/react/shallow'
import {
  useThumbnailTrackingStore,
  type ThumbnailTrackingEntry,
} from '@/stores/useThumbnailTrackingStore'
import { useThumbnailSSE } from '@/hooks/useThumbnailSSE'

function ThumbnailSSEConnection({ entry }: { entry: ThumbnailTrackingEntry }) {
  useThumbnailSSE(entry)
  return null
}

export function ThumbnailTracker() {
  const entries = useThumbnailTrackingStore(
    useShallow(s => [...s.entries.values()])
  )

  return (
    <>
      {entries.map(entry => (
        <ThumbnailSSEConnection key={entry.lineId} entry={entry} />
      ))}
    </>
  )
}
